import React, {useState} from "react";
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import dayjs from "dayjs";
import "dayjs/locale/fr";

import {api} from "../../../services/apiService";

export default function ExportBookingsDialog({open, onClose}) {
  const [since, setSince] = useState(dayjs().startOf("month"));
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    if (exporting) return;
    setError(null);
    onClose();
  };

  const handleExport = () => {
    setExporting(true);
    setError(null);
    api.get("/bookings/export", {
      params: {since: since.format("YYYY-MM-DD")},
      responseType: "blob"
    })
      .then(response => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Réservations Domaine des Vieilles Pierres depuis le ${since.format("DD-MM-YYYY")} - export Rezaly.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setExporting(false);
        onClose();
      })
      .catch(err => {
        console.error("Error exporting bookings:", err);
        setError("Impossible de générer l'export.");
        setExporting(false);
      });
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
      <DialogTitle>Exporter les réservations</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{mb: 2}}>
          Toutes les réservations créées à partir de cette date seront exportées au format Excel.
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
          <DatePicker
            label="Créées depuis le"
            value={since}
            onChange={setSince}
            disableFuture
            slotProps={{textField: {fullWidth: true}}}
          />
        </LocalizationProvider>
        {error && <Alert severity="error" sx={{mt: 2}}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={exporting}>Annuler</Button>
        <Button
          variant="contained"
          startIcon={<FileDownloadIcon/>}
          onClick={handleExport}
          loading={exporting}
          disabled={!since || !since.isValid()}
        >
          Exporter
        </Button>
      </DialogActions>
    </Dialog>
  );
}
